import React from "react";
import "./App.css";
import { Box } from "@mui/material";
import { Routes, Route } from "react-router-dom";
import routes from "./routes/routes";
import Navbar from "./shared/navbar/navbar";
import Footer from "./shared/footer/footer";
import BackdropWrapper from "./shared/backdrop/backdrop";

const App = () => {
  return (
    <>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          minHeight: "100vh",
        }}
      >
        <Box sx={{ flexGrow: 1 }}>
          <BackdropWrapper
            colour={"linear-gradient(135deg, #0f0f0f 0%, #1a1a2e 100%)"}
          />
          <Navbar />
          <Routes>
            {routes.map((route, index) => (
              <Route key={index} path={route.path} element={route.element} />
            ))}
          </Routes>
        </Box>
      </Box>
      <Footer />
    </>
  );
};

export default App;
